import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { apiProvider } from '../../api';
import { dropdownList, filter, localState, props } from './state';
import { mutations } from './mutations';
import { actions } from './actions';
import { NAME, CRUMB_LABEL_KEY } from '../../constants';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	filter,
	tableSetting: {},
	rowDetail: null,
	localState,
	extraActions: actions,
	extraMutations: mutations,
	extraGetters: {},
	props,
});
